export default __webpack_public_path__ + "static/media/pdf.dda76f6b.svg";